<ui-icon-bs [pseudo]="'white'" [type]="bsIconTypes.Printer" [handlers]="handlers" />
